import { getSelf as getSelfStored } from "Areas/Settings/users";
import { security } from "Common/permissions";
const userId = security.getCurrentUserId();
const userLogin = security.userLogin() || "";
const user = {
    Id: userId,
    Login: userLogin,
    Name: userLogin
};
export const getSelf = (state) => (getSelfStored(state) || user);
